import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { darken } from '@/(routers)/boards/editor/block/blockTheme';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';

const BLOCK_COLOUR = '#ffffff';

const OPERATOR_OPTIONS = [
    { value: 'TRUE', label: '真', tooltip: '条件が成立しているとき [true]' },
    { value: 'FALSE', label: '偽', tooltip: '条件が成立していないとき [false]' },
];

defineBlock({
    type: 'bool',
    colour: BLOCK_COLOUR,
    strokeColour: darken('#a9b2b6'),
    tooltip: '真または偽の値',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'BOOL',
                    instance: () =>
                        new FieldOperatorDropdown(OPERATOR_OPTIONS, undefined, undefined, undefined, 'small'),
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        this.setColour(BLOCK_COLOUR);

        const syncDropdownColour = () => {
            const parent = this.getParent();
            const colour = parent ? parent.getColour() : '#a9b2b6';
            const field = this.getField('BOOL') as FieldOperatorDropdown | null;
            field?.setRectColour(colour);

            const stroke = darken(colour);
            requestAnimationFrame(() => {
                (this as Blockly.BlockSvg).pathObject?.svgPath?.setAttribute('stroke', stroke);
            });
        };

        const origSetParent = this.setParent.bind(this);
        this.setParent = (parent: Blockly.Block | null) => {
            origSetParent(parent);
            requestAnimationFrame(() => syncDropdownColour());
        };

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                (this as Blockly.BlockSvg).pathObject?.svgPath?.setAttribute('fill', '#ffffff');
                syncDropdownColour();
            });
        });
    },
});
